import { Directive, ElementRef, Input, OnInit, OnDestroy, Optional, TemplateRef, ViewContainerRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as fromAuth from 'app/auth/store';
import * as fromRoot from 'app/core/store';

@Directive({
  selector: '[eboAccessByRole]'
})
export class AccessByRoleDirective implements OnInit, OnDestroy {
  @Input() eboAccessByRole: string[] | string;

  private subscription: Subscription;
  private hasView = false;

  constructor(
    private elementRef: ElementRef,
    private store: Store<fromRoot.AppState>,
    private viewContainerRef: ViewContainerRef,
    @Optional() private templateRef: TemplateRef<any>
  ) {}

  ngOnInit(): void {
    const comparisonArray: string[] = Array.isArray(this.eboAccessByRole)
      ? this.eboAccessByRole
      : [this.eboAccessByRole];

    this.subscription = this.store.pipe(select(fromAuth.getUserRoles)).subscribe(roles => {
      const hasAccess = Array.isArray(roles) && comparisonArray.some(r => roles.includes(r));

      if (this.templateRef) {
        // Structural directive mode (*eboAccessByRole)
        if (hasAccess && !this.hasView) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
          this.hasView = true;
        } else if (!hasAccess && this.hasView) {
          this.viewContainerRef.clear();
          this.hasView = false;
        }
      } else {
        // Attribute directive mode on real DOM elements
        const style = this.elementRef?.nativeElement?.style;
        if (!style) { return; }
        style.display = hasAccess ? '' : 'none';
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
